
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as GalleryIconComponent } from "./gallery-icon.svg";

export const GalleryIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <GalleryIconComponent {...props} />;
};
